<template>
    <b-button-group>
        <slot />
    </b-button-group>
</template>

<script>
import { BButtonGroup } from 'bootstrap-vue'

export default {
    components: { BButtonGroup },
}
</script>